import { SVGProps, Ref, forwardRef } from 'react';

export const EmojiHalfsmileOutlinedSize32Glyph = forwardRef(
    (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
        <svg
            width={32}
            height={32}
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={ref}
            {...props}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M3.734 16c0-3.19.117-5.52.445-7.261.324-1.719.81-2.626 1.372-3.188S7.021 4.502 8.74 4.18C10.48 3.85 12.81 3.733 16 3.733s5.52.118 7.262.446c1.718.323 2.625.81 3.187 1.372s1.049 1.47 1.372 3.188c.328 1.741.446 4.071.446 7.26s-.117 5.52-.446 7.262c-.323 1.719-.81 2.626-1.372 3.188-.562.561-1.47 1.048-3.187 1.372-1.742.328-4.072.446-7.262.446s-5.52-.118-7.261-.446c-1.718-.324-2.626-.81-3.188-1.372-.561-.562-1.048-1.47-1.372-3.188-.328-1.741-.446-4.071-.446-7.261m-2.4 0C1.334 3.167 3.167 1.333 16 1.333S30.667 3.167 30.667 16 28.833 30.667 16 30.667 1.334 28.833 1.334 16m12.874 6.112c-.24-.255-.341-.524-.341-.779h-2.4c0 .947.394 1.785.991 2.422.86.914 2.157 1.445 3.542 1.445 1.386 0 2.683-.53 3.542-1.445.598-.637.991-1.475.991-2.422h-2.4c0 .255-.101.524-.34.779-.358.38-.997.688-1.793.688s-1.434-.307-1.792-.688m4.126-9.445c0-1.167.583-2.334 2.333-2.334S23 11.5 23 12.667C23 13.833 22.417 15 20.667 15s-2.334-1.167-2.334-2.333m-7-2.334C9.584 10.333 9 11.5 9 12.667 9 13.833 9.584 15 11.334 15s2.333-1.167 2.333-2.333-.583-2.334-2.333-2.334"
                fill="currentColor"
            />
        </svg>
    )
);
EmojiHalfsmileOutlinedSize32Glyph.displayName = 'EmojiHalfsmileOutlinedSize32Glyph';
